<template>
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Line Rounded/Sharee" clip-path="url(#clip0_2440_6364)">
      <path
        id="Vector"
        d="M17.8333 5.33301V10.6663C9.06667 12.037 5.80667 19.717 4.50001 26.6663C4.45067 26.941 11.6787 18.717 17.8333 18.6663V23.9997L28.5 14.6663L17.8333 5.33301Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>

    <defs>
      <clipPath id="clip0_2440_6364">
        <rect width="32" height="32" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>
